import React from "react";

const ConfirmPage = () => {
  return <h1>Your Account Was Succesfully Created</h1>;
};

export default ConfirmPage;
